module.exports = __webpack_public_path__ + "cuttingLineSlideAlt.jpg?476b447e458ce1f89d4dd30abe5fac8a";